export function isSupportedBrowser() {
  if (window.navigator.userAgent.indexOf('Trident/') > 0) {
    document.body.innerHTML =
      '<div id="ie-message"><h1>Sorry this application is not supported for Internet Explorer. ' +
      '<br /> Please use Chrome, Firefox, or Microsoft Edge.</h1></div>';
  }
}
